import { render, staticRenderFns } from "./candidateListPanel.vue?vue&type=template&id=1d1152e5&"
import script from "./candidateListPanel.vue?vue&type=script&lang=js&"
export * from "./candidateListPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports